import { selectors } from 'data'
import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { isCompact } from 'utils'

import DesktopSignedIn from './DesktopSignedIn'
import MobileSignedIn from './MobileSignedIn'

type Props = ConnectedProps<typeof connector>

const SignedInContainer = ({ hasMoney, isCompact, user, walletGuid, walletUrl }: Props) => {
  const SignedInComponent = isCompact ? MobileSignedIn : DesktopSignedIn
  // should never happen
  if (!user) return null

  return (
    <SignedInComponent
      hasMoney={hasMoney}
      user={user}
      walletGuid={walletGuid}
      walletUrl={walletUrl}
    />
  )
}

const mapStateToProps = (state) => ({
  hasMoney: selectors.balance.hasMoney(state),
  isCompact: isCompact(selectors.app.getScreenWidth(state)),
  user: selectors.auth.getUser(state),
  walletGuid: selectors.auth.getWalletGuid(state),
  walletUrl: selectors.config.getConfig(state).walletUrl
})

const connector = connect(mapStateToProps)
export default connector(SignedInContainer)
